import React, { useEffect } from 'react'

import PropTypes from 'prop-types'

import PrimaryButton from '@lyrahealth-inc/ui-core/lib/atoms/buttons/primaryButton/PrimaryButton'

import styles from './requestPayment.module.scss'
import { track } from '../../../mixpanel/mixpanelTracking'

const OutcomeReminder = ({ firstName, outcomeSentDate, closeFunc }: any) => {
  useEffect(() => {
    track({ event: 'OUTCOME_REMINDER' })
  }, [])
  return (
    <div className={styles['modal-content']}>
      <h2 className={styles['main-header']}>Please remind {firstName} to submit Outcomes</h2>
      <p>
        We requested outcomes from {firstName} on {outcomeSentDate} but haven&apos;t received them. As you know,
        Outcomes data is important for tracking progress in therapy, catching any problems early, and supporting
        successful graduation.{' '}
        <b>
          Please ask {firstName} to submit Outcomes on a computer or mobile device by opening the link we sent via
          email.
        </b>
      </p>
      <PrimaryButton onClick={() => closeFunc()}>OK</PrimaryButton>
    </div>
  )
}

OutcomeReminder.propTypes = {
  outcomeSentDate: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  closeFunc: PropTypes.func.isRequired,
}

export default OutcomeReminder
